var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_module"},[_c('div',{on:{"click":function($event){_vm.clickDeleteOptionsOpenEmployee(),
        _vm.clickDeleteOptionsOpenEmployeeThreeDots()}}},[(!_vm.dataCheck && !_vm.getEditProfile)?_c('div',[_c('TableEmployeeSkeleton')],1):(_vm.noResult)?_c('div',{staticClass:"container-slots container-base"},[_c('h1',[_vm._v("no results")])]):_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }